import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await register(form.name, form.email, form.password); nav("/dashboard"); }
    catch (e) { setErr(apiError(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <main className="mx-auto flex max-w-md flex-col px-5 py-16">
      <div className="mb-6 flex items-center gap-2">
        <span className="grid h-9 w-9 place-items-center rounded-lg bg-teal-500 text-white"><ShieldCheck className="h-5 w-5" /></span>
        <span className="font-heading text-xl font-bold">Create your account</span>
      </div>
      <div className="card-surface p-7">
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Name</Label><Input data-testid="register-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5 border-[#DDDAD1] bg-ink-900" required /></div>
          <div><Label>Email</Label><Input data-testid="register-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 border-[#DDDAD1] bg-ink-900" required /></div>
          <div><Label>Password</Label><Input data-testid="register-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5 border-[#DDDAD1] bg-ink-900" minLength={6} required /></div>
          {err && <p data-testid="register-error" className="text-sm text-coral-500">{err}</p>}
          <button data-testid="register-submit" disabled={loading} className="btn-teal w-full disabled:opacity-50">{loading ? "Creating…" : "Create account"}</button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-400">Already have an account? <Link to="/login" className="text-teal-400 hover:text-teal-300">Sign in</Link></p>
      </div>
    </main>
  );
}
